import React, {useEffect, useState} from "react";
import Select from "react-select";
import AsyncSelect from "react-select/async/dist/react-select.esm";

export const CompanySelect = ({options, onChange, defaultValue, isInvalid}) => {
    let [selectOptions, setSelectOptions] = useState([]);

    useEffect(() => {
        function parse() {
            let newOptions = [];

            if (options) {
                options.forEach(option => {
                    newOptions.push({
                        ...option,
                        value: option.id,
                        label: option.company.company_name,
                    });
                });
            }

            setSelectOptions(newOptions)
        }

        parse();

        return function () {
            setSelectOptions([]);
        }
    }, [options])

    return (
        <Select
            styles={{
                control: (provided, state) => (isInvalid ? {
                    ...provided, borderColor: 'red',
                } : provided)
            }}
            options={selectOptions} defaultValue={defaultValue} onChange={onChange}></Select>
    );
}
